import { FC } from 'react';
import { useAuctionTimeRemaining } from 'src/hooks/Auction/useAuctionTimeRemaining';
import styles from './SubInfo.module.scss';

interface SubInfoProps {
  open_seat_count?: number;
  closeDate?: string;
}

export const SubInfo: FC<SubInfoProps> = ({ open_seat_count, closeDate }) => {
  const auctionTimeRemaining = useAuctionTimeRemaining(closeDate);

  return (
    <div className={styles.container}>
      <div className={styles.info}>
        <div className={styles.countdown}>{auctionTimeRemaining}</div>
        <div
          className={styles.seats}
          style={{ display: 'flex', justifyContent: 'space-between' }}
        >
          <span>{open_seat_count} seats available</span>
          <button className={styles.btn}>
            <a
              href="https://dunbar148.com/how-it-works"
              target="_blank"
              rel="noopener noreferrer"
            >
              How it works
            </a>
          </button>
        </div>
      </div>
    </div>
  );
};
